'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { pick, debounce, isEqual } from 'underscore';
import text from 'I18n/utils/unescapedText';
import UITextInput from 'UIComponents/input/UITextInput';
import UIFlex from 'UIComponents/layout/UIFlex';
import ToolFieldset from 'DesignComponents/tool/ToolFieldset';
import { MIN, CHOICES, DEFAULT, VALIDATION_REGEX, OBJECT_TYPE, SUPPORTED_SOURCE_TYPES, TABLE_NAME_OR_ID } from 'DesignData/enums/CustomWidgetFieldAttributes';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import CommandBar from 'DesignEditorsUI/components/shared/controls/commandBar/CommandBar';
import CommandBarButton from 'DesignEditorsUI/components/shared/controls/commandBar/CommandBarButton';
import FieldLabel from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/FieldLabel';
import FormControlWithErrors from 'DesignEditorsUI/components/customWidgetEditor/sidebar/FormControlWithErrors';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.${key}`;

class StyleGroupEdit extends PureComponent {
  constructor(props) {
    super(props);

    this.editField = changes => {
      const {
        customWidgetId
      } = this.props;
      const {
        field
      } = this.state;
      const updatedField = field.merge(changes);
      this.setState({
        field: updatedField
      });
      this.debouncedEditField(customWidgetId, updatedField);
    };

    this.debouncedEditField = debounce(function debouncedEditField(customWidgetId, updatedField) {
      this.props.editField(customWidgetId, updatedField);
    }, 1000);

    this.onDeleteClick = () => {
      this.props.deleteField(this.props.customWidgetId, this.props.field.id);
    };

    this.onNameChange = e => {
      const name = e.target.value;
      this.editField({
        name
      });
    };

    this.state = {
      field: props.field
    };
  }

  componentDidUpdate(prevProps) {
    const {
      field
    } = this.props;

    if (!isEqual(prevProps.field, field)) {
      this.setState({
        field
      });
    }
  }

  get contentOptionsErrors() {
    const {
      fieldErrors
    } = this.props;
    return pick(fieldErrors, [MIN, CHOICES, DEFAULT, VALIDATION_REGEX, OBJECT_TYPE, SUPPORTED_SOURCE_TYPES, TABLE_NAME_OR_ID]);
  }

  get fieldName() {
    const breadcrumbsPath = this.props.fieldBreadcrumbs.map(_field => _field.name).join('.');
    return breadcrumbsPath || this.state.field.name;
  }

  renderNameInput() {
    const {
      fieldErrors,
      readOnly
    } = this.props;
    const {
      field
    } = this.state;
    return /*#__PURE__*/_jsx(ToolFieldset, {
      children: /*#__PURE__*/_jsx(FormControlWithErrors, {
        className: "field-name-input m-y-4",
        errors: fieldErrors.name,
        label: text(i18nKey('nameLabel')),
        children: /*#__PURE__*/_jsx(SidebarInput, {
          className: "is--code",
          inputComponent: UITextInput,
          onChange: this.onNameChange,
          value: field.name,
          disabled: readOnly
        })
      })
    });
  }

  render() {
    const {
      customWidgetId,
      readOnly
    } = this.props;
    const {
      field
    } = this.state;

    if (!field) {
      return null;
    }

    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        align: "start",
        justify: "between",
        direction: "row",
        wrap: "nowrap",
        "data-test-id": "style-tab-controls",
        children: [/*#__PURE__*/_jsx(FieldLabel, {
          customWidgetId: customWidgetId,
          editField: this.editField,
          field: field,
          isReadOnly: readOnly
        }), /*#__PURE__*/_jsx(CommandBar, {
          children: /*#__PURE__*/_jsx(CommandBarButton, {
            title: text(i18nKey('deleteGroup')),
            iconName: "delete",
            onClick: this.onDeleteClick,
            isReadOnly: readOnly
          })
        })]
      }), this.renderNameInput()]
    });
  }

}

StyleGroupEdit.propTypes = {
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  deleteField: PropTypes.func.isRequired,
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField),
  fieldBreadcrumbs: PropTypes.array,
  fieldErrors: PropTypes.object,
  readOnly: PropTypes.bool
};
StyleGroupEdit.defaultProps = {
  customWidgetIcon: null,
  field: null,
  fieldErrors: {},
  fieldBreadcrumbs: []
};
export default StyleGroupEdit;